import React from 'react';
import { FaUser } from 'react-icons/fa';
import './UserAvatar.css';

/**
 * Renders the user's profile picture or a default icon.
 * Used in Profile page, Navbar, and dropdown so the avatar is identical everywhere.
 * Avatar can be a URL string or a data URL (e.g. from file input).
 */
const UserAvatar = ({ avatar, className = '', size }) => {
  const style = size ? { width: size, height: size, minWidth: size, minHeight: size } : undefined;

  return (
    <div className={`user-avatar ${className}`.trim()} style={style}>
      {avatar ? (
        <img src={avatar} alt="" className="user-avatar-img" />
      ) : (
        <span className="user-avatar-icon">
          <FaUser />
        </span>
      )}
    </div>
  );
};

export default UserAvatar;
